import React from 'react';

/**
 * PracticeBadge
 *
 * Tiny pill that flags a class as a warm-up or exhibition. Used consistently
 * across the rider entry form, producer schedule, and kiosk so anywhere a
 * class title shows up, riders & staff can tell at a glance that this is a
 * practice/no-payout class.
 *
 * Returns null for standard classes so callers can drop it in without
 * conditionally wrapping every render site.
 */
export const PracticeBadge = ({ classType, size = 'sm' }) => {
  if (!['warmup', 'exhibition'].includes(classType)) return null;
  const label = classType === 'warmup' ? 'WARM-UP' : 'EXHIBITION';
  const cls = size === 'xs'
    ? 'px-1 py-[1px] text-[8px]'
    : 'px-1.5 py-0.5 text-[9px]';
  return (
    <span
      className={`${cls} bg-[#34C759]/15 text-[#34C759] rounded font-bold uppercase tracking-wider whitespace-nowrap`}
      data-testid={`practice-badge-${classType}`}
      title="Practice class — no payout, no placings"
    >
      {label}
    </span>
  );
};

export default PracticeBadge;
